import { render, staticRenderFns } from "./verified.vue?vue&type=template&id=1bf3c560&scoped=true&"
import script from "./verified.vue?vue&type=script&lang=js&"
export * from "./verified.vue?vue&type=script&lang=js&"
import style0 from "./verified.vue?vue&type=style&index=0&id=1bf3c560&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf3c560",
  null
  
)

export default component.exports